import { AppRoutes } from '../common/constants';
import { Box, Card, CardContent, Tab, Tabs, Typography } from '@mui/material';
import { JSX, useMemo, useState } from 'react';
import { QuoteItem } from '../common/types/quotes';
import { useQuery } from '@tanstack/react-query';
import Content from '../common/components/content';
import Layout from '../common/components/layout';
import Quotes from './quotes';

export const breadcrumbs = [
  { label: 'Dashboard', href: '/' },
  { label: 'Quotes', href: AppRoutes.Quotes },
];

/**
 * Render list of quotes
 */
const QuotesPage = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState(0);
  const { data } = useQuery<QuoteItem[]>({
    queryKey: ['/FNAQuoteLists'],
  });

  const quotesTotals = data?.reduce<Record<string, number>>(
    (accumulator, item) => ({
      ...accumulator,
      [item.typeNote]: (accumulator[item.typeNote] || 0) + 1,
    }),
    {},
  );

  const availableTypeNames = useMemo(() => Object.keys(quotesTotals || {}), [quotesTotals]);

  const quotes = useMemo(() => {
    if (!data) {
      return undefined;
    }

    if (activeTab === 0) {
      return data;
    }

    return data.filter((item) => item.typeNote === availableTypeNames[activeTab - 1]);
  }, [activeTab, data, availableTypeNames]);

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <Content>
        <Typography variant="h2">Quotes</Typography>

        <Card className="mt-4">
          <CardContent>
            <Box className="grid grid-cols-6">
              <Box>
                <Typography variant="body1" color="text.secondary">
                  Total quotes
                </Typography>
                <Typography variant="h1">{data?.length}</Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>

        <Card className="mt-4">
          <Tabs
            className="mb-4"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            value={activeTab}
            onChange={(_, newValue: number): void => setActiveTab(newValue)}
          >
            <Tab label="All" />
            {availableTypeNames.map((type) => (
              <Tab key={type} label={type} />
            ))}
          </Tabs>
          <Quotes quotes={quotes} />
        </Card>
      </Content>
    </Layout>
  );
};
export default QuotesPage;
